import {WebsiteModuleState} from "../models/website-module.state";
import {WEBSITE_MODULE} from "../website-module.consts";
import {ActionHandler} from "../../../infrastructure/handlers/action-handler";

export class WebsiteModuleStickyExternalAdDisplayHandler extends ActionHandler {
  type = WEBSITE_MODULE.ACTION_TYPES.stickyExternalAdDisplayHandler;
  state: WebsiteModuleState;

  onLoaded() {
    super.onLoaded();
    this.state.isStickyExternalAdVisible = this.state.shouldDisplayStickyExternalAd;
  }


  action({isVisible}) {
    this.state.isStickyExternalAdVisible = isVisible;
  }

}
